import type { DestinationCardData } from '../types/destinationCards';

export const DEFAULT_FEATURED_DESTINATIONS: DestinationCardData[] = [
  {
    name: 'Italy',
    searchTerm: 'Italy',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-683962492:cards-strd-600x400',
  },
  {
    name: 'France',
    searchTerm: 'France',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-1815364539:cards-strd-600x400',
  },
  {
    name: 'Hawaii',
    searchTerm: 'Hawaii',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-1397681795:cards-strd-600x400',
  },
  {
    name: 'Mexico',
    searchTerm: 'Mexico',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-1945140880:cards-strd-600x400',
  },
  {
    name: 'Caribbean',
    searchTerm: 'Caribbean',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-103822101:cards-strd-600x400',
  },
  {
    name: 'Japan',
    searchTerm: 'Japan',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-1441083322:cards-strd-600x400',
  },
];

export const DEFAULT_POPULAR_DESTINATIONS: DestinationCardData[] = [
  {
    name: 'Canada',
    searchTerm: 'Canada',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-1599827836:cards-strd-600x400',
  },
  {
    name: 'Argentina',
    searchTerm: 'Argentina',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-2196380973:cards-strd-600x400',
  },
  {
    name: 'Portugal',
    searchTerm: 'Portugal',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-639053494:cards-strd-600x400',
  },
  {
    name: 'Turkey',
    searchTerm: 'Turkey',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-1050859762:cards-strd-600x400',
  },
  {
    name: 'Vietnam',
    searchTerm: 'Vietnam',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-1417912195:cards-strd-600x400',
  },
  {
    name: 'Saudi Arabia',
    searchTerm: 'Saudi Arabia',
    image:
      'https://assets.ace.aaa.com/is/image/aceaaa/GettyImages-2202043615:cards-strd-600x400',
  },
];
